const messages = {
  title: "Bonus-Multiplikator",
  bandBonusTitle: "Bonus pro Reifen beim Multiplikator",
  amountLabel: "Min. Anzahl Reifen (*)",
  label: "Bonus-Multiplikator",
  desc: "Anzahl Bridgestone- und Firestone-Reifen. Es gibt keinen Bonus in Euro auf Firestone-Reifen.",
  goals: {
    loyal: "Loyal",
    bronze: "Bronze",
    silver: "Silber",
    gold: "Gold",
    platinum: "Platin",
  },
  andMore: "und mehr",
  chooseTarget: "Auswählen",
  selectTarget: "Wählen Sie hier Ihr Jahresziel {year} aus:",
  multiplication: "Bonus wird mit <b>{factor}</b> multipliziert",
  minTyres: "<b>Minimum:</b> {tyre} Reifen",
};

export default {
  messages,
};
